var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "login-main-section bgcolor-e4e9ef col-12 float-l" },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "mobile-login-section" }),
        _vm._v(" "),
        _c("div", { staticClass: "middle-login-section bgcolor-ffffff" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "btm-login-form-main float-l width-full" }, [
            _c(
              "h2",
              {
                staticClass:
                  "color-333333 heading-text-22 line-height-26 float-l width-full center font-text-regular ucase m-0"
              },
              [_vm._v(" Sign In ")]
            ),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass:
                  "color-888888 heading-text-12 line-height-16 float-l width-full center font-text-regular"
              },
              [_vm._v(" Sign in to continue ")]
            ),
            _vm._v(" "),
            _c("form", [
              _c("div", { staticClass: "login-form float-l col-12" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("div", { staticClass: "fl-flex-label" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.username,
                                expression: "username"
                              }
                            ],
                            staticClass: "form-control ks-rounded",
                            attrs: {
                              type: "text",
                              name: "username",
                              id: "default-input-rounded",
                              placeholder: "Email Address",
                              required: ""
                            },
                            domProps: { value: _vm.username },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.username = $event.target.value
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "help is-danger" }, [
                          _vm._v(_vm._s(_vm.email_error_msg))
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "div",
                          { staticClass: "fl-flex-label password-field" },
                          [
                            _vm.pType === "checkbox"
                              ? _c("input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    },
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.password,
                                      expression: "password"
                                    }
                                  ],
                                  staticClass: "form-control ks-rounded",
                                  attrs: {
                                    name: "password",
                                    id: "default-input-rounded-1",
                                    placeholder: "Password",
                                    required: "",
                                    type: "checkbox"
                                  },
                                  domProps: {
                                    checked: Array.isArray(_vm.password)
                                      ? _vm._i(_vm.password, null) > -1
                                      : _vm.password
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.password,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.password = $$a.concat([$$v]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.password = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.password = $$c
                                      }
                                    }
                                  }
                                })
                              : _vm.pType === "radio"
                              ? _c("input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    },
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.password,
                                      expression: "password"
                                    }
                                  ],
                                  staticClass: "form-control ks-rounded",
                                  attrs: {
                                    name: "password",
                                    id: "default-input-rounded-1",
                                    placeholder: "Password",
                                    required: "",
                                    type: "radio"
                                  },
                                  domProps: {
                                    checked: _vm._q(_vm.password, null)
                                  },
                                  on: {
                                    change: function($event) {
                                      _vm.password = null
                                    }
                                  }
                                })
                              : _c("input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    },
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.password,
                                      expression: "password"
                                    }
                                  ],
                                  staticClass: "form-control ks-rounded",
                                  attrs: {
                                    name: "password",
                                    id: "default-input-rounded-1",
                                    placeholder: "Password",
                                    required: "",
                                    type: _vm.pType
                                  },
                                  domProps: { value: _vm.password },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.password = $event.target.value
                                    }
                                  }
                                }),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "view-icon",
                                attrs: { href: "javascript:void(0)" },
                                on: {
                                  click: function($event) {
                                    return _vm.hideShow(this)
                                  }
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "hi-icon icon-chatview"
                                })
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "help is-danger" }, [
                          _vm._v(_vm._s(_vm.password_error_msg))
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group btm-login-web" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "right-forget-text col-6 col-md-6 col-lg-6 col-xl-6 float-r"
                      },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "a",
                            {
                              staticClass:
                                "color-f5911e heading-text-13 line-height-17 font-medium float-r right width-full",
                              attrs: {
                                href: _vm.forgot_pass_url,
                                target: "_blank"
                              }
                            },
                            [_vm._v(" Forgot your Password? ")]
                          )
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "help is-danger" }, [
                    _vm._v(_vm._s(_vm.error_msg_login))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "login-btn width-full float-l" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { id: "loginbtn", type: "submit" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.login(this)
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "gradient" }),
                        _vm._v("  Login \n                                  ")
                      ]
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "btm-page-link float-r width-full" },
              [
                _c(
                  "router-link",
                  {
                    staticClass:
                      "color-6d6e70 heading-text-14 line-height-18 font-regular right float-r",
                    attrs: { to: { name: "PrivacyPolicy" } }
                  },
                  [_vm._v(" Privacy Policy ")]
                )
              ],
              1
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "vvg-logo-img width-full float-l" }, [
      _c("div", { staticClass: "vvg-logo-internal" }, [
        _c("img", {
          attrs: {
            src: "/static/images/login-logo-small.png",
            alt: "Chat Logo"
          }
        })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-657094ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-657094ba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/Login.vue
// module id = null
// module chunks = 